<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add @invoke-method="invokeMethod($event)" :add-list="addList" perm="configuration.update"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetDistributor()"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="distributor != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <v-flex xs8 py-0>
                                    <bc-tooltip right :disabled="!hasPerm('configuration.update')">
                                        <template slot="activator">
                                            <v-btn
                                                v-if="hasPerm('configuration.update')"
                                                style="max-width: 120px; text-transform: none"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="distributor.status_class"
                                                text-color="white"
                                                @mouseup.left="dbChangedStatus()"
                                            >
                                                <v-icon color="white" class="mr-2" v-model="editStatus.status">{{
                                                    status_loader ? "fas fa-circle-notch fa-spin" : "check_circle"
                                                }}</v-icon>
                                                <span class="white--text">{{
                                                    status_loader ? $t("lang.loading") : distributor.status == "1" ? $t("lang.active") : $t("lang.disabled")
                                                }}</span>
                                            </v-btn>
                                            <v-chip
                                                v-else
                                                disabled
                                                round
                                                text-color="white"
                                                class="chip-padding-left-4 mr-auto fs-14"
                                                :color="distributor.status_class"
                                            >
                                                <span><v-icon class="mr-2">check_circle</v-icon></span>
                                                <span class="white--text">{{ distributor.status == "1" ? $t("lang.active") : $t("lang.disabled") }}</span>
                                            </v-chip>
                                        </template>
                                        {{ editStatus.status == "0" ? $t("lang.click_to_activate") : $t("lang.click_to_deactivate") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <div class="ml-auto">
                                        <bc-tooltip perm="configuration.update">
                                            <template slot="activator">
                                                <v-btn @mouseup.left="openCompanyModal()" icon>
                                                    <v-icon color="indigo">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t("lang.modify_distributor") }}
                                        </bc-tooltip>
                                    </div>
                                </v-flex>
                                <v-flex xs12 py-0 :class="{ 'prevent-click': !hasPerm('configuration.update') }">
                                    <bc-tooltip top>
                                        <template slot="activator">
                                            <v-img
                                                :src="showErrorImg ? errorImg : distributor.logo"
                                                height="150px"
                                                width="150px"
                                                class="rounded-circle mx-auto clickable"
                                                @mouseup.left="$refs.croppa.chooseFile()"
                                                :key="updatePhoto"
                                                @error="showErrorImg = true"
                                            ></v-img>
                                        </template>
                                        {{ $t("lang.uploadImage") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex py-1>
                                    <p class="display-1 mb-0 text-xs-center">{{ distributor.company }}</p>
                                    <a class="display-0 mb-0 text-xs-center" :href="'http://' + distributor.website" target="_blank">{{
                                        distributor.website
                                    }}</a>
                                </v-flex>
                            </v-layout>
                            <v-divider v-if="distributor.entity_phones" class="my-0"></v-divider>
                            <bc-list
                                v-if="distributor.entity_phones"
                                :items="distributor.entity_phones"
                                prepend-icon="phone"
                                perm="companies.update"
                                @invoke-method="showPhone($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.phone_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="distributor.entity_addresses" class="my-0"></v-divider>
                            <bc-list
                                v-if="distributor.entity_addresses"
                                :items="distributor.entity_addresses"
                                prepend-icon="location_on"
                                perm="companies.update"
                                @invoke-method="showAddress($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ $t(`lang.${data.item.address_type}`) }}</v-flex>
                                    <v-flex list-sub>{{ data.item.address1 }}</v-flex>
                                    <v-flex list-sub>{{ `${data.item.city}, ${data.item.state} ${data.item.zip_code}` }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="info" perm="configuration.update" @invoke-method="openCompanyModal">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.account_number")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ distributor.account_number || "---" }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.correspondence_method")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{
                                                distributor.correspondence_method ? $t(`lang.${distributor.correspondence_method}`) : "---"
                                            }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.currency_code")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ distributor.currency_code || "---" }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.payment_terms")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ distributor.payment_terms_description || "---" }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.has_nda")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ distributor.has_nda == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.has_contract")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ distributor.has_contract == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="description" perm="configuration.update" @invoke-method="openCompanyModal">
                                <template>
                                    <v-flex title>{{ $t("lang.notes") }}</v-flex>
                                    <v-flex style="white-space: pre-line">{{
                                        distributor.notes ? distributor.notes : $t("lang.none") | shrink_text(250)
                                    }}</v-flex>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <div>
                                <bc-tabs
                                    :tabs="subComponents"
                                    :selectedComponent="selectComponent(selectedComponent)"
                                    @button="$nextTick(() => (selectedComponent = $event))"
                                    :update-params="true"
                                >
                                </bc-tabs>
                                <v-card elevation="0" :key="refresh">
                                    <keep-alive>
                                        <component v-if="subComponentsMap[selectedComponent]" :is="component" class="tab"></component>
                                    </keep-alive>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>

        <bc-dialog :value="company_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.modify_distributor") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="company_dialog"
                        :dialog-status="company_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="company_form">
                        <v-container pa-0 grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 column>
                                    <v-text-field
                                        v-model="distributor.company"
                                        :label="$t('lang.company')"
                                        :counter="showCounter(distributor.company, 'distributor.company')"
                                        :rules="ifValid('distributors.company')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="distributor.account_number"
                                        :label="$t('lang.account_number')"
                                        :counter="showCounter(distributor.account_number, 'distributor.account_number')"
                                        :rules="ifValid('distributors.account_number')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="distributor.website"
                                        :label="$t('lang.website')"
                                        :counter="showCounter(distributor.website, 'distributor.website')"
                                        :rules="ifValid('distributors.website')"
                                    ></v-text-field>
                                    <bc-autocomplete
                                        v-model="distributor.payment_term_id"
                                        :label="$t('lang.payment_terms')"
                                        :items="payment_terms"
                                        item-value="payment_term_id"
                                        item-text="description"
                                        :rules="ifValid('distributors.payment_term_id')"
                                    ></bc-autocomplete>
                                    <bc-autocomplete
                                        v-model="distributor.currency_id"
                                        :label="$t('lang.currency_id')"
                                        :items="currencies"
                                        item-value="currency_id"
                                        item-text="name"
                                        :rules="ifValid('distributors.currency_id')"
                                    ></bc-autocomplete>
                                    <v-textarea v-model="distributor.notes" :label="$t('lang.notes')" auto-grow rows="1" :key="growText"></v-textarea>
                                </v-flex>
                                <v-flex xs12 sm6 column align-self-start>
                                    <span class="fs-12 grey-label">{{ $t("lang.has_nda") }}</span>
                                    <v-switch
                                        v-model="distributor.has_nda"
                                        :label="distributor.has_nda == '1' ? $t('lang.yes') : $t('lang.no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                    <span class="fs-12 grey-label">{{ $t("lang.has_contract") }}</span>
                                    <v-switch
                                        v-model="distributor.has_contract"
                                        :label="distributor.has_contract == '1' ? $t('lang.yes') : $t('lang.no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                    <span class="fs-12 grey-label">{{ $t("lang.correspondence_method") }}</span>
                                    <v-switch
                                        v-model="distributor.correspondence_method"
                                        :label="distributor.correspondence_method == 'electronic' ? $t('lang.electronic') : $t('lang.mail')"
                                        true-value="electronic"
                                        false-value="mail"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="company_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="saveDistributors()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
        <bc-phone-dialog
            ref="phoneDialog"
            object_ref="companies"
            :object_id="$route.params.id"
            :total_items="distributor.entity_phones || []"
            :scope="distributor.scope"
            @eventname="updatePhones"
        ></bc-phone-dialog>
        <bc-address-dialog
            ref="addressDialog"
            object_ref="companies"
            :object_id="$route.params.id"
            :total_items="distributor.entity_addresses || []"
            :scope="distributor.scope"
            @eventname="updateAddresses"
        ></bc-address-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

import { distributorProfileComponents } from "Modules/companies/distributors/components/profile.data.js";

export default {
    data() {
        return {
            subComponentsMap: {},
            subComponents: distributorProfileComponents,
            selectedComponent: "shipments",
            component: null,
            tabs: [{ title: "shipments", name: "Shipments" }],
            validPhone: false,
            dbChangedStatus: _.debounce(this.changeStatus, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetDistributor: _.debounce(this.getDistributor, 1500, { maxWait: 1500, leading: true, trailing: false }),
            addList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", icon: "phone" },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", icon: "location_on" },
            ],
            mobileList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", perms: ["configuration.update"] },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", perms: ["configuration.update"] },
                { title: this.$t("lang.refresh"), action: "dbGetDistributor" },
            ],
            company_dialog: false,
            distributor: {
                company: "",
                website: "",
                notes: "",
                logo: "",
                payment_term_id: "",
            },
            editStatus: { status: "" },
            status_loader: false,
            file: "",
            newFile: {
                logo_file: "",
            },
            refresh: 0,
            growText: 0,
            updatePhoto: 0,
            errorImg: AppConfig.defaultProfileLogo,
            showErrorImg: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchDistributor", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.distributor) {
                        this.distributor = this.assignObj2(data.distributor, this.rules_distributors);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=distributor_status&sort_by=2",
                            method: "get",
                            stateProperty: "distributor_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "distributors", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchDistributor", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.distributor) {
                        next((vm) => {
                            vm.distributor = vm.assignObj2(data.distributor, vm.rules_distributors);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=distributor_status&sort_by=2",
                                method: "get",
                                stateProperty: "distributor_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "distributors", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_distributors: (state) => state.distributors.rules_distributors,
            distributor_status_options: (state) => state.settings.distributor_status_options,
            distributors: (state) => state.distributors.distributors,
            selectedDistributor: (state) => state.distributors.selectedDistributor,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
        }),
    },
    created() {
        this.registerComponents();
    },
    methods: {
        ...mapActions(["fetchDistributor", "saveDistributor", "deleteDistributor", "printDistributor", "fetchCurrencies", "fetchPaymentTerms"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        registerComponents() {
            this.subComponents.forEach((cData) => {
                cData.import().then((component) => {
                    this.$set(this.subComponentsMap, cData.name, component.default);
                });
            });
        },
        selectComponent(componentName) {
            this.component = this.subComponentsMap[componentName];
        },
        getDistributor(pg_refresh = false) {
            this.startLoader();

            this.fetchDistributor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.distributor) {
                    this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        saveDistributors() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("company_form")) {
                    let body = this.prepForm(this.distributor, this.rules_distributors);

                    this.saveDistributor({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.distributor) {
                            this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                            this.validationOff();
                            this.company_dialog = false;
                        }
                        this.toggleModalLoader(false);
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let status = this.distributor.status == 1 ? 0 : 1;
            let body = { company_id: `${this.$route.params.id}`, status: status };

            this.saveDistributor({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.distributor) {
                    this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                    this.status_loader = false;
                    this.finishLoader();
                }
            });
        },
        deleteDistributors() {
            this.deleteDistributor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "distributors" });
                }
                this.toggleModalLoader(false);
            });
        },
        handleFileUpload(file) {
            let body = { company_id: `${this.$route.params.id}`, logo_file: file };
            this.saveDistributor({
                body: body,
            })
                .then((data) => {
                    if (typeof data != "undefined" && data.distributor) {
                        this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                        this.validationOff();
                        this.company_dialog = false;
                    }
                    this.toggleModalLoader(false);
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },
        async openCompanyModal() {
            this.company_dialog = true;
            this.growText++;

            if (this.payment_terms.length == 0) await this.fetchPaymentTerms({ body: { options: 1 } });
            if (this.currencies.length == 0) await this.fetchCurrencies({ body: { options: 1 } });
        },
        updateAddresses(addresses) {
            this.distributor.entity_addresses = addresses;
        },
        updatePhones(phones) {
            this.distributor.entity_phones = phones;
        },
        showAddress(item) {
            if (item) this.$refs.addressDialog.showAddress(item);
        },
        showPhone(item) {
            if (item) this.$refs.phoneDialog.showPhone(item);
        },
        async refresh_page(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchDistributor({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.distributor) {
                        this.distributor = this.assignObj2(data.distributor, this.rules_distributors);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
            if (this.exchange_rates.length == 0 || force == true) await this.fetchExchangeRates({ body: { options: 1 } });
            if (this.distributor_status == 0 || force == true) await this.fetchOptions({ body: { slug: "distributor_status" } });
        },
    },
};
</script>
